<template>
    <div>
        <card-header title="Applications & Forms" icon="fa-file-certificate"/>

        <card-toolbar>
            <button @click="$openCard('new-application', {}, card)"><i class="far fa-plus"></i>New Application</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <application-tile
                    :application="a"
                    :card="card"
                    v-for="a in applications"
                    @click="$openCard('application', {applicationId: a.id}, card)"
                    :active="child && child.definition.component === 'application' && child.props.applicationId == a.id"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import CourseTile from "@/components/tiles/CourseTile";

    import {client as http} from "@/http_client";
    import ApplicationTile from "../../components/tiles/ApplicationTile.vue";

    export default {
        components: {ApplicationTile, CourseTile, CardToolbar, SeparatorListItem, CardHeader, CardBody, CardList, SearchListItem},
        props: ['card', 'child'],
        data() {
            return {
                applications: []
            }
        },
        methods: {
            loadCourses: function (force) {
                this.$emit('loading', true);

                http.get('applications', {force}).then(response => {
                    this.applications = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function() {
                this.loadCourses(true);
            }
        },
        mounted: function() {
            this.loadCourses();
        }
    }
</script>
